import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import CustomPaper from "src/component/uiElements/customPaper/customPaper";
import PageHeading from "src/component/pageHeading/pageHeading";
import UseRecidentialPropertyInformation from "./useRecidentialPropertyInformation";

type PgPropertyDetailsScreenProps = {
    list?: any;
};
const RecidentialPropertyInformationScreen = ({ list }: PgPropertyDetailsScreenProps) => {
    const {
        financialDetails,
        OwnersDetails,
        propertyDetails,
        amenitiesDetails,
        mediaDetails,
        specificationDetails
    } = UseRecidentialPropertyInformation(list);


    return (
        <>
            <CustomPaper>

                <form
                    noValidate
                    style={{ width: "100%" }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <PageHeading firstHeading="Property Measurements" lastHeading="Details" />
                        </Grid>

                        {financialDetails && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <div><strong>Built Up Area:</strong> {financialDetails.BuiltUpAreaSqFt || "N/A"}</div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div><strong>Carpet Area:</strong> {financialDetails.CarpetAreaSqFt || "N/A"}</div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div><strong>Monthly Rent:</strong> ₹ {financialDetails.MonthlyRent?.toLocaleString("en-IN") || "N/A"}</div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div><strong>Security Deposit:</strong> ₹ {financialDetails.SecurityDeposit?.toLocaleString("en-IN") || "N/A"}</div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div><strong>Maintenance Charges:</strong> ₹ {financialDetails.MaintenanceCharges?.toLocaleString("en-IN") || "N/A"}</div>
                                </Grid>
                            </>
                        )}
                    </Grid>

                </form>

            </CustomPaper>

            {/* <CustomDualBudgetRangeSlider
        label="Budget Range"
        min={1}
        max={500000}
        value={budgetRange}
        setValue={setBudgetRange}
      /> */}
        </>
    );
};

export default RecidentialPropertyInformationScreen;
